<div>
  <app-spinner *ngIf="loading || (loadingTransformers && componentType === 'transformer')" [sizeClass]="'large'"></app-spinner>

  <div *ngIf="!loading && !(loadingTransformers && componentType === 'transformer')">
    <div class="row">
    <app-filter-list #filterList
                     (removeAllFiltersEvent)="removeAllFilters()" (selectedFiltersEvent)="updateComponentList($event)"
                     *ngIf="filters && filters.length > 0"
                     [filters]="filters"
                     [resetFilters]="resetFilters"
                     class="col-2 scrollable scrollFilterListSize"
                     id="filters_id">
    </app-filter-list>

    <app-card-list [addingTransformerInfos]="transformerInfos" [componentsLength]="currentItemct.components.length" [components]="displayedComponents"
                   class="col-10 undo-bootstrap-padding scrollable scrollListSize"
                   id="cards">
    </app-card-list>
    </div>
  </div>
</div>



